/**
 * Header-based session ID fallback for cross-site deployments (nano.fitracking.com
 * talking to api.tryfi.com). Chrome blocks third-party cookies in this scenario, so the
 * fi.sid session cookie never reaches the API. The backend already supports an
 * x-session-id header as an alternative — this module persists the session ID returned
 * in auth responses to localStorage and attaches it to subsequent requests.
 *
 * Using localStorage rather than an in-memory variable ensures the session ID survives
 * page refreshes.
 */

const STORAGE_KEY = 'fi_session_id';

export function getSessionId() {
  return localStorage.getItem(STORAGE_KEY);
}

export function setSessionId(id: string) {
  localStorage.setItem(STORAGE_KEY, id);
}

export function clearSessionId() {
  localStorage.removeItem(STORAGE_KEY);
}
